import {LobbyGameInfoDefaultBox} from './lobby-game-info.default.box';

export const LobbyGameInfoBox = LobbyGameInfoDefaultBox;